<lms-modal size="small">
  <div class="gl-popup__title gap-bottom">{{ 'actions.updateEmail' | translate }}</div>
  <div class="gl-popup__close">
    <span class="glicon-close" (click)="close()"></span>
  </div>

  <ng-container *ngIf="['form', 'error'].includes(step)">
    <lms-dynamic-form
      #emailUpdateForm
      [action]="'students.change-email'"
      [questions]="questions"
      [options]="{ disableCard: true }"
      (submit)="submit($event.email)"
    >
    </lms-dynamic-form>
  </ng-container>

  <ng-container *ngIf="step === 'confirmation'">
    <div class="gl-popup__text">{{ confirmationMessageLabel | translate }}</div>

    <div class="gl-popup__buttons position-static padding-top__big">
      <gl-button color-secondary [text]="'actions.cancel' | translate" (onClick)="close()"> </gl-button>
      <gl-button color-primary [text]="'actions.confirm' | translate" (onClick)="submit(newEmail, true)"></gl-button>
    </div>
  </ng-container>
</lms-modal>
